module.exports = __webpack_public_path__ + "img/application-title-m.b563b802.png";